import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Empty_LetterRequestCustomer_Device_Interface, LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LetterRequestCustomerDevice',
  templateUrl: './LetterRequestCustomerDevice.component.html',
  styleUrls: ['./LetterRequestCustomerDevice.component.scss']
})
export class LetterRequestCustomerDeviceComponent implements OnInit {

  Token:String=""
  Procssing:boolean=false
  ProcssingOperation:boolean=false
  Letter_Id:number
  CanEdit:boolean=true
  page:number=0

  constructor(
    private LetterRequestCustomer_Service:LetterRequestCustomerService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    this.Letter_Id = Number(this.route.snapshot.paramMap.get('id'))
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1116).subscribe(
      data=>{
        this.Read_DevoceLetter()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }


  DeviceFormList:Array<LetterRequestCustomer_Device_Interface>=[]
  Selected_LetterRequestCustomer_Device:LetterRequestCustomer_Device_Interface=Empty_LetterRequestCustomer_Device_Interface()
  Selected_LetterRequestCustomer_Device_Int:Number=0
  Read_DevoceLetter(){
    this.Procssing=true
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerDeviceListDetail(this.Letter_Id,0,0,this.Token).subscribe(
      data=>{
        this.Procssing=false
        this.DeviceFormList=data
      },error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  OnBack(){
    this.Selected_LetterRequestCustomer_Device=Empty_LetterRequestCustomer_Device_Interface()
  }

  SetRecord(item:LetterRequestCustomer_Device_Interface){
    this.Selected_LetterRequestCustomer_Device=item
    this.Selected_LetterRequestCustomer_Device_Int=this.DeviceFormList.indexOf(item)+1
  }

  SubmitDevice(){
    var numbers = new RegExp(/^[+-0-9+-]+$/);

    if(!numbers.test(this.Selected_LetterRequestCustomer_Device.gostareh+''))
    {
      this.Alertify_Service.ErrorMessage("Check the required calibration point or range.")
    }
    else{
      this.ProcssingOperation=true

      this.LetterRequestCustomer_Service.PostLetterRequestCustomerDevice_Detail(
        this.Selected_LetterRequestCustomer_Device.id,
        this.Selected_LetterRequestCustomer_Device.deviceCode,
        this.Selected_LetterRequestCustomer_Device.deviceSerial,
        this.Selected_LetterRequestCustomer_Device.gostareh+"",
        this.Selected_LetterRequestCustomer_Device.deviceCustomerDsc,
        this.Token).subscribe(
        data=>{
          this.ProcssingOperation=false
          this.Alertify_Service.SuccessMessage("The instrument information was saved successfully.")
          this.Read_DevoceLetter()
        },error=>{
          localStorage.clear()
          location.reload();
        }
      )
    }
  }


}
